import { linkOptions } from "@tanstack/react-router";

/**
 * O tipo de `to` é validado pelo próprio linkOptions, que só aceita rotas
 * existentes. Aqui o link fica com a forma aceita por linkOptions para poder
 * ser guardado numa lista sem prender o tipo a uma rota específica.
 */
export type NavLink = Parameters<typeof linkOptions>[0];

export type NavItem = { label: string; link: NavLink };

export const tratamentosItems: NavItem[] = [
  { label: "Emagrecimento e saúde metabólica", link: linkOptions({ to: "/tratamentos/emagrecimento/" }) },
  { label: "Saúde hormonal", link: linkOptions({ to: "/tratamentos/saude-hormonal/" }) },
  { label: "Massa muscular e sarcopenia", link: linkOptions({ to: "/tratamentos/massa-muscular/" }) },
  { label: "Medicina do esporte", link: linkOptions({ to: "/tratamentos/medicina-do-esporte/" }) },
  { label: "Longevidade e qualidade de vida", link: linkOptions({ to: "/tratamentos/longevidade/" }) },
  { label: "Estética e medicina regenerativa", link: linkOptions({ to: "/tratamentos/estetica-regenerativa/" }) },
];

export const conteudosItems: NavItem[] = [
  { label: "Blog", link: linkOptions({ to: "/blog/" }) },
  { label: "Vídeos", link: linkOptions({ to: "/videos/" }) },
];

export const contatoItems: NavItem[] = [
  { label: "Consultório em Bauru", link: linkOptions({ to: "/bauru/" }) },
  { label: "Teleconsulta", link: linkOptions({ to: "/consulta-online/" }) },
  { label: "Contato", link: linkOptions({ to: "/contato/" }) },
];

export const homeLink = linkOptions({ to: "/" });
export const bauruLink = linkOptions({ to: "/bauru/" });
export const avaliacao360 = linkOptions({ to: "/tratamentos/avaliacao-360/" });
export const sobreLink = linkOptions({ to: "/sobre/" });
export const metodoSpLink = linkOptions({ to: "/saude-com-proposito/" });
export const contatoLink = linkOptions({ to: "/contato/" });
export const privacidadeLink = linkOptions({ to: "/politica-de-privacidade/" });
export const blogLink = linkOptions({ to: "/blog/" });
export const videosLink = linkOptions({ to: "/videos/" });
export const teleconsultaLink = linkOptions({ to: "/consulta-online/" });
export const consultaOnlineLink = teleconsultaLink;

export const LOGO_ALT = "ITV, Instituto Dr. Thiago Viana";
